import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, EffectRef, Signal } from '@angular/core';
import { DigitalServiceContentModel } from '@libs/cms/models';
import { ContentBaseComponent } from '../content-base.component';
import { DIGITAL_SERVICE_COMPONENT_MAP, ServiceComponent } from './helper/digital-service-component-map';

@Component({
  selector: 'ui-digital-service',
  templateUrl: './digital-service.component.html',
  styleUrls: ['./digital-service.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class DigitalServiceComponent extends ContentBaseComponent<DigitalServiceContentModel> {
  private readonly serviceComponentEffectRef: EffectRef = effect(() => {
    if (!this.serviceComponent()) {
      console.error('digital-service: component not found', this.data().service);
    }
  });

  public readonly serviceComponent: Signal<ServiceComponent | null> = computed(() => {
    const service: string = this.data().service;

    return DIGITAL_SERVICE_COMPONENT_MAP[service] ?? null;
  });
}
